'use client';

import { toInternationalNumber } from '@/utils/get-dial-code';
import WhatsAppIcon from '../icons/whatsapp-icon';

type WhatsAppChatSupportProps = {
  whatsappSupportPhone: string;
};

export default function WhatsappChatSupport({
  whatsappSupportPhone,
}: WhatsAppChatSupportProps) {
  const phone = toInternationalNumber(whatsappSupportPhone);
  const link = `https://wa.me/${phone}`;

  return (
    <a
      href={link}
      target="_blank"
      rel="noopener noreferrer"
      aria-label="WhatsApp Support"
      className="flex h-12 w-12 items-center justify-center rounded-fulls
        duration-300 hover:scale-105 hover:shadow-xl"
    >
      <WhatsAppIcon className="size-20" />
    </a>
  );
}
